export const packingGroups = {
  'Layers & trail': ['Waterproof hiking boots', 'Warm base layers', 'Insulated jacket', 'Waterproof shell', 'Gloves', 'Beanie', 'Traction devices / microspikes', 'Daypack'],
  'Daily essentials': ['Refillable water bottle', 'Binoculars', 'Portable charger', 'Sunglasses', 'Sunscreen', 'Offline maps'],
  'Travel & wellness': ['Passport', 'Travel insurance information', 'Medication', 'Swimsuit for hot springs / pools'],
}

export const safetyNotes = [
  'Purchase or rent bear spray after arrival; it cannot normally fly on a commercial aircraft.',
  'Carry bear spray accessibly and review how to use it.',
  'Never approach wildlife, especially elk; follow Parks Canada distance rules.',
  'Check trail reports, Parks Canada bulletins, weather, and Alberta 511 each morning.',
  'Download offline maps and never rely on cell service in remote areas.',
]

export const reservations = ['Lodging', 'Avis rental vehicle', 'Roam / Parks Canada lake shuttle', 'Banff Gondola', 'Sky Bistro', 'Columbia Icefield', 'Lake Minnewanka Cruise', 'Special dinners', 'Spa or afternoon tea', 'Park pass']
